import React, { useState } from 'react'
import {useNavigate} from 'react-router-dom';

const SignUp = (props) => {
    const [credentials,setCredentials]=useState({ name:'',email:'', password:'',cpassword:''})
    const navigate = useNavigate();
   
    const handleSubmit= async (e)=>{
        e.preventDefault();
        const {name,email,password}=credentials;
        const response = await fetch("http://localhost:5000/api/auth/createuser", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ name,email,password}),
            });
            const json= await response.json()
            console.log(json)
           
            if (json.success){
                localStorage.setItem('authoken' ,json.authToken)
                navigate('/');
                props.showAlert('Account Created Successfully','success')

            }
            else{
              props.showAlert('Invalid Credentials','danger')
            }

        }
        const onChange=(e)=>{
            setCredentials({...credentials, [e.target.name]:e.target.value})
        }

  return (
    <div className='mt-2'>
      <h2 className='my-2'>Create an account to use iCloud</h2>
      <form onSubmit={handleSubmit}>
      <div className="my-3">
      <label htmlFor="name" className="form-label">Name</label>
    <input type="text" className="form-control" name='name'id="name"  aria-describedby="emailHelp" onChange={onChange} required />
    </div>
    <div className="my-3">
     <label htmlFor="email" className="form-label">Email address</label>
     <input type="email" className="form-control" name='email' id="email"  aria-describedby="emailHelp" onChange={onChange} required />
  </div>
  <div className="my-3">
    <label htmlFor="password" className="form-label">Password</label>
    <input type="password" className="form-control" name='password'  id="password" onChange={onChange} minLength={5} required  />
  </div>
  <div className="my-3">
    <label htmlFor="cpassword" className="form-label">Confirm Password</label>
    <input type="password" className="form-control" name='cpassword' id="cpassword"onChange={onChange} minLength={5} required  />
  </div>
  
  <button type="submit" className="btn btn-primary" >Submit</button>
 </form>
    </div>
  )
  
}

export default SignUp
